import { Btn } from "../../../../AbstractElements";
import { FinishWizardButton, NextWizardButton, PreviousWizardButton } from "../../../../Constant";
import { toast } from "react-toastify";
import { RegisterWizardButtonProp } from "../../../../Type/Pages";

export const RegisterWizardButtons = ({showFinish,level,handleBackButton,handleNextButton}:RegisterWizardButtonProp) => {
  return (
    <div className="action-bar">
      {level === 4 && (<Btn color="primary" onClick={() => toast.success("form submitted successfully")}>{FinishWizardButton}</Btn>)}
      {level < 5 && (<Btn color="primary" className={showFinish ? "buttonDisabled" : ""} onClick={handleNextButton}>{NextWizardButton}</Btn>)}
      {level > 1 && (<Btn color="primary" onClick={handleBackButton}>{PreviousWizardButton}</Btn>)}
    </div>
  );
};
